import { Component, inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { purgeRegistrationSecrets } from './app/pages/auth/register/registration-handoff';
import { PrimeNG } from 'primeng/config';
import { bindHtmlLang } from './app/utils/html-lang';
import { bindPrimeNgLocale } from './app/utils/primeng-locale';
import { resolveInitialLanguage } from './app/utils/initial-language';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {
    private translateService = inject(TranslateService);

    constructor() {
        // Eski surumun localStorage'da biraktigi duz metin kayit parolasini temizle.
        purgeRegistrationSecrets();
        // <html lang> secili dili izlesin (CSS uppercase tr: ŞİRKET, ŞIRKET degil).
        bindHtmlLang(this.translateService, inject(DOCUMENT));
        // Takvim ay/gun adlari secili dilde olsun (PrimeNG varsayilani Ingilizce).
        bindPrimeNgLocale(this.translateService, inject(PrimeNG));
        // Initialize language on construction
        this.initializeLanguage();
    }

    ngOnInit() {
        // Ensure translations are loaded
        this.ensureTranslationsLoaded();
    }

    private initializeLanguage() {
        // Get language from localStorage first
        const savedLang = localStorage.getItem('language');

        if (savedLang && ['en', 'tr', 'bg', 'de'].includes(savedLang)) {
            // If we have a saved language, use it immediately
            this.translateService.setDefaultLang(savedLang);
            this.translateService.use(savedLang);
        } else {
            // Set default language to Turkish as per user preference
            this.translateService.setDefaultLang('tr');

            // Tarayıcı dili tr* ise tr; değilse desteklenen tarayıcı dili, o da yoksa tr (initial-language.ts).
            const finalLanguage = resolveInitialLanguage({
                saved: savedLang,
                navigatorLanguage: typeof navigator !== 'undefined' ? navigator.language : null,
                browserLang: this.translateService.getBrowserLang(),
                browserCultureLang: this.translateService.getBrowserCultureLang()
            });

            // Set the language immediately
            this.translateService.use(finalLanguage);

            // Save the detected language
            localStorage.setItem('language', finalLanguage);
        }
    }

    private ensureTranslationsLoaded() {
        const currentLang = this.translateService.currentLang || localStorage.getItem('language') || 'tr';

        // Set default and current language
        this.translateService.setDefaultLang('tr');
        this.translateService.use(currentLang).subscribe(
            (res) => {},
            (err) => console.error('Error loading translations:', err)
        );
    }
}
